import { IonIcon } from "@/components/icons/AppIcon";
import { WEB_APP_URL } from "@/lib/assets";

const base =
  "inline-flex items-center justify-center gap-2 rounded-xl text-sm font-semibold transition-[background-color,border-color,color,transform] duration-200 active:scale-[0.98]";

export function OpenAppButton({ testid = "open-waidbook-btn", className = "" }) {
  return (
    <a
      href={WEB_APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${base} bg-[#CAA362] px-5 py-3 text-[#1A1509] hover:bg-[#E0BE82] ${className}`}
    >
      Open Waidbook
      <IonIcon name="open-outline" size={17} />
    </a>
  );
}

export function LoginButton({ testid = "login-btn", className = "" }) {
  return (
    <a
      href={WEB_APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${base} border border-[#2C2E29] bg-[#1C1D1A] px-5 py-3 text-[#EAEBE7] hover:border-[#CAA362]/50 hover:text-[#E0BE82] ${className}`}
    >
      <IonIcon name="log-in-outline" size={18} />
      Inloggen
    </a>
  );
}
